import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import {
  TIERS,
  TIER_LABELS,
  productRoleName,
  parseProductRoleName,
} from "../../utils/common/productRoles";

const serverConfig = require("../../config/server.js");

/*
 * Two-dropdown (Product + Role) product-role picker, shared across every
 * "add/update user" screen (ManageUsers.jsx, Users.jsx, and future
 * product-internal access panels). Purely a selection UI: the caller owns
 * the pending list of flat role names (e.g. "109-contributor") via
 * `value`/`onAdd`/`onRemove` and decides what to do with them (merge into a
 * user_grant_role call, diff against existing roles, etc).
 */
const ProductRoleAssigner = ({ token, value, onAdd, onRemove, fixedProductId }) => {
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedTier, setSelectedTier] = useState("");

  useEffect(() => {
    if (token === null || token === undefined) {
      return;
    }
    axios
      .post(serverConfig.api_base_url + "product_roles_list_get", { token: token })
      .then((response) => {
        console.log("product_roles_list_get response", response.data.items);
        if (response.data.status === 200) {
          setProductOptions(response.data.items !== null ? response.data.items : []);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((err) => console.log("error is", err));
  }, [token]);

  const productNameById = (productId) => {
    const found = productOptions.find((p) => p.product_id === productId);
    return found ? found.product_name : productId;
  };

  const handleAdd = () => {
    const productId = fixedProductId !== undefined ? fixedProductId : Number(selectedProductId);
    if (!productId || !selectedTier) {
      return;
    }
    const flatName = productRoleName(productId, selectedTier);
    if (!value.includes(flatName)) {
      onAdd(flatName);
    }
    setSelectedProductId("");
    setSelectedTier("");
  };

  return (
    <div className="product-role-assigner">
      <Row className="align-items-center">
        {fixedProductId === undefined && (
          <Col>
            <Form.Select
              aria-label="Product"
              className="rounded-0"
              value={selectedProductId}
              onChange={(e) => setSelectedProductId(e.target.value)}
            >
              <option value="">Product</option>
              {productOptions.map((item) => (
                <option value={item.product_id} key={item.product_id}>
                  {item.product_name}
                </option>
              ))}
            </Form.Select>
          </Col>
        )}
        <Col>
          <Form.Select
            aria-label="Product Role"
            className="rounded-0"
            value={selectedTier}
            onChange={(e) => setSelectedTier(e.target.value)}
          >
            <option value="">Role</option>
            {TIERS.map((tier) => (
              <option value={tier} key={tier}>
                {TIER_LABELS[tier]}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs="auto">
          <button
            type="button"
            className="btn-transparent modal-add-btn"
            onClick={handleAdd}
          >
            Add
          </button>
        </Col>
      </Row>
      {value.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {value.map((flatName) => {
            const parsed = parseProductRoleName(flatName);
            const label = parsed
              ? `${productNameById(parsed.productId)} - ${TIER_LABELS[parsed.tier]}`
              : flatName;
            return (
              <span key={flatName} className="modal-chip">
                {label}
                <button
                  type="button"
                  className="modal-chip-remove"
                  onClick={() => onRemove(flatName)}
                  aria-label={`Remove ${label}`}
                >
                  &times;
                </button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductRoleAssigner;
